import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    accountConfirmed: false,
    email: "",
    error: false,
    errorPhrase: ""
}

const accountConfirmSlice = createSlice({
    name: "accountConfirm",
    initialState,
    reducers: {
        accountConfirmed: (state, action) => {
            state.accountConfirmed = true
            state.email = action.payload.email
        },
        confirmationAccountError: (state, action) => {
            state.error = true
            state.errorPhrase = action.payload.errorPhrase
        },
        reset: state => initialState,
    },
})

export const { accountConfirmed, confirmationAccountError, reset } = accountConfirmSlice.actions
export default accountConfirmSlice.reducer